import { combineReducers } from 'redux';
import { commonReducer } from './common';
import { messageReducer } from './messages';
import { attendanceReducer } from './attendance';
import { mqttReducer } from './mqtt';
import { leaveDateReducers } from './leaveDateList';
// import { shiftDetailReducers } from './shiftDeatilOfUser';
import shiftDetailReducers from './shiftDeatilOfUser/shiftDetail.Reducers';
import dashboardReducer from './dashboard/dashboard.Reducer';
import { settingReducers } from './Setting';
import {otpsReducers} from './otps';
const appReducer = combineReducers({
  common: commonReducer,
  messages: messageReducer,
  mqtt: mqttReducer,
  attendance: attendanceReducer,
  setting:settingReducers,
  leaveDate: leaveDateReducers,
  shiftDetail: shiftDetailReducers,
  dashboardDetail: dashboardReducer,
  // setting: settingReducers,
  otp: otpsReducers,
});

const rootReducer = (state, action) => {
  const { type, payload } = action;
  let newState;

  if (type === 'APP_INIT') {
    newState = { ...state, internal: {} };
  } else if (type === 'RELOAD_STORE') {
    newState = { ...payload };
  } else if (type === 'CLEAR_INTERNAL_STORE') {
    newState = { routing: { ...state.routing } };
  }

  return appReducer(newState || state, action);
};

export default rootReducer;
